import Card, { CardProps } from '@mui/material/Card';
import { styled } from '@mui/material/styles';

const BaseCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
}));

export type { CardProps };
export default BaseCard;
